import { render, staticRenderFns } from "./StatisticAndAnalysis.vue?vue&type=template&id=c94b8aae&scoped=true&"
import script from "./StatisticAndAnalysis.vue?vue&type=script&lang=js&"
export * from "./StatisticAndAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./StatisticAndAnalysis.vue?vue&type=style&index=0&id=c94b8aae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c94b8aae",
  null
  
)

export default component.exports